import { AllEventsPageConnector } from '@/events/pages/all-events/connector';
import { AllEventsPageComponent } from '@/events/pages/all-events/component';

export const AllEventsPage = AllEventsPageConnector(AllEventsPageComponent);
